module.exports = __webpack_public_path__ + "373236f54883a9d0a03e7803913dd5f9.svg";